import * as React from 'react';
import { Dispatch } from 'redux';
import { useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom'
import { CardImg, Col, Input, Button, Row, FormGroup } from "reactstrap";
import { languageAction } from '../../actions/languageAction';
import { channelAction } from '../../actions/channelAction';
import { userAction } from '../../actions/userAction';
import { DABDropDown, DABTextBox, DABInlineLoading, LoadingSpinnerModal, ConfirmModal } from '../../components/dab';
import { Capitalize, showAlert } from "../common/functions";
import moment from 'moment';
import MessageBoardEngagement from "./messageBoardEngagement";
import ChannelEngegement from "./channelEngagement";
import UserAddress from "./userAddress";
import UserMessages from './messages';
import UserPurchaseDetail from './userPurchaseDetail';
import EpisodeEngagement from './episodeDetail'
import UserRole from './userRole'
import NoImage from '../../assets/images/noimage.png'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { log } from 'console';

interface IUsersProps {
	dispatch: Dispatch<any>;
	channelData: any;
	userData: any;
	callback: any;
	id: number;
	languageData: any;
	messageBoardData: any;
	episodeData: any;
}

const UserDetail: React.SFC<IUsersProps> = ({ dispatch, channelData, userData, id, languageData, messageBoardData, episodeData }) => {
	let dateFormat = "MM/DD/YYYY";
	const history = useHistory();
	const isTest = sessionStorage.getItem('isTest');
	const userInput = {
		userId: -1,
		userName: "",
		firstName: "",
		lastName: "",
		password: "",
		cnfPassword: "",
		isActive: false,
		isAdmin: false,
		languageCode: '',
		roleCodes: [""],
		authorChannelsIds: [0],
		isDeleted: false,
		phoneNumber: '',
		textsAllowed: false,
		emailsAllowed: false,
		registeredAtUtc: '',
		birthDate: '',
		email: '',
		avatarImageUrl: '',
		avatarUrlUploaded : ''
	}

	const channel = { title: "", id: 0, description: "", isActive: false, checked: false, iconImage: "" };
	const [isRoleLoaded, setIsRoleLoaded] = useState(false);
	const [isChannelLoaded, setIsChannelLoaded] = useState(false);
	const initialValue = [{ text: "", value: 0, checked: false }];
	const [channelList, setChannelList] = useState([channel]);
	const [rolesList, setRolesList] = useState(initialValue);
	const [frmInput, setFrmInput] = useState(userInput);
	const [isActive, setIsActive] = useState(false);
	const [isAdmin, setIsAdmin] = useState(false);
	const [isDeleted, setIsDeleted] = useState(false);
	const [isEditUserData, setIsEditUserData] = useState(false);
	const [showModal, setShowModal] = useState(false); 
	const [showFavChnModal, setShowFavChnModal] = useState(false); 
	const [favChannelList, setFavChannelList] = useState([]);
	const [shownonFavChnModal, setShownonFavChnModal] = useState(false);
	const [nonFavChannelList, setnonFavChannelList] = useState([]);
	const [isDetailLoaded, setIsDetailLoaded] = useState(false);
	const [isErrorOnPage, setIsErrorOnPage] = useState(false); 
	const [languageCode, setLanguageCode] = useState("");
	const [langList, setLangList] = useState([{ text: "English", value: "en", checked: false }]);
	const [isLangListLoaded, setIsLangListLoaded] = useState(false);
	const [isAllDataLoaded, setIsAllDataLoaded] = useState(false); 
	const [showUserDeactivateModal, setShowUserDeactivateModal] = useState(false);
	const [textsAllowed, setTextsAllowed] = useState(false);
	const [emailsAllowed, setEmailsAllowed] = useState(false);
	const [formSubmit, setformSubmit] = useState(false);
	const [languageName, setLanguageName] = useState("");
	const [favChannelId, setFavChannelId] = useState(-1);
	const [favChannelTitle, setFavChannelTitle] = useState("");
	const [isDirty, setIsDirty] = useState<boolean>(false);
	const [error, setError] = useState(" ");
	const [isInvalidUrl, setIsInvalidUrl] = useState(false);
	const [imagePrevUrl, setImagePrevUrl] = useState<any>();

	const initialnonFavChannelInput = {
		userId: id
	};
	const initialFavChannelInput = {
		pageNumber: 1,
		pageSize: 3,
		userId: id
	};
	const [filterFavChannelInput, setFilterFavChannelInput] = useState(initialFavChannelInput);

	React.useEffect(() => {
		dispatch(channelAction.channelGetByfilter());
		dispatch(userAction.userRoleGetByFilter());
		dispatch(languageAction.languageGetByfilter());
		dispatch(channelAction.channelGetFavourite(filterFavChannelInput));
		dispatch(channelAction.channelGetNonFavourite(initialnonFavChannelInput));
		dispatch(userAction.userGetDetail(id));
		setIsAllDataLoaded(true);
		setShowFavChnModal(true);
	}, []);

	if (userData) {
		if (formSubmit && userData.isSuccess && !userData.isError) {
			if (userData.status) {
				window.localStorage.setItem('alertMessage', userData.status);				
				window.location.href = "/dashboard?id=" + frmInput.userId;
			}
		}		

		if (userData.isDetailComplete) {	
			if (!isDetailLoaded && userData.item) {				
				setFrmInput(userData.item);
				setImagePrevUrl(userData.item.avatarUrlUploaded || userData.item.avatarImageUrl)
				setIsDetailLoaded(true);
				setIsActive(userData.item.isActive);
				setIsAdmin(userData.item.isAdmin);
				setIsDeleted(userData.item.isDeleted);
				setEmailsAllowed(userData.item.emailsAllowed);
				setTextsAllowed(userData.item.textsAllowed);				
				if (userData.item.channelIds) {
					userData.item.channelIds.split(',').forEach((obj) => {
						var index = channelList.findIndex(x => x.id === obj);
						if (index > -1) { channelList[index].checked = true; }
					});
					setChannelList(channelList);
				}
				if (userData.item.favoriteChannelId > 0) {
					var favChanId = userData.item.favoriteChannelId;
					setFavChannelId(favChanId);
					dispatch(channelAction.channelGetDetail(favChanId,""));
				}
			}
			if (showModal) {
				setShowModal(false);
			}

			if (userData.isError) {
				window.location.href="/404"
			}
			
		}

		if (userData.isSuccess
			&& userData.isUserAcitiveStatusLoaded
			&& !userData.isError) {
			userData.isUserAcitiveStatusLoaded = false;
			userData.isSuccess = false;
			showAlert(userData.status, false);
			setShowModal(false);
			setIsActive(false);
		}

		if (!userData.isSuccess && !userData.isUserAddRoleLoaded && userData.isError) {
			userData.isError = false;
			if (userData.status === 'Unauthorized') {
				history.push("/401");
			} else {
				showAlert(userData.status, true);
			}
			setShowModal(false);
		}	

	}

	if (languageData && userData && userData.isDetailComplete && userData.item && userData.item.languageCode && userData.item.languageCode.length > 0) {
		if (languageData.items.length > 0 && languageData.isSuccess) {
			languageData.items.forEach((data) => {
				if (data.languageCode.toLowerCase() === userData.item.languageCode.toLowerCase()) {
					setLanguageName(data.name);
					setLanguageCode(userData.item.languageCode);
				}
			});
			languageData.isSuccess = false;
		}
	}
	
	if (!isChannelLoaded && !channelData.isLoading) {
		if (channelData.isListSuccess) {
			channelData.isListSuccess = false;
			setIsChannelLoaded(true);
			
			if (channelList && channelList.length <= 1) {
				var list: any[] = [];
				channelData.items.forEach((data) => {
					var item1 = {
						text: data.title,
						id: data.channelId,
						description: data.descriptionHtml,
						iconImage: data.iconImage,
						checked: false
					};
					list.push(item1);
				});
				setChannelList(list);
			}
		}
	}
		
	if (channelData && channelData.isFavChannelLoaded) {
		channelData.isFavChannelLoaded = false;
		setShowFavChnModal(false);
		setFavChannelList(channelData.favChannelData);
	}
		
	if (channelData && channelData.isnonFavChannelLoaded) {
		channelData.isnonFavChannelLoaded = false;
		setShownonFavChnModal(false);
		setnonFavChannelList(channelData.nonFavChannelData);
	}

	if (!isRoleLoaded && !userData.isLoading) {
		if (userData.isRoleListSuccess) {
			setIsRoleLoaded(true);
			
			if (rolesList && rolesList.length <= 1) {
				var list0: any[] = [];
				userData.rolesList.forEach((data) => {
					list0.push({ text: data.roleName, value: data.roleCode, checked: false });
				});
				setRolesList(list0);
			}
		}
	}

	if (langList && !isLangListLoaded) {
		if (languageData.items.length > 0) {
			var list1: any[] = [];
			languageData.items.forEach((data) => {
				list1.push({ text: data.name, value: data.languageCode, checked: true });
			});
			setLangList(list1);

			if (frmInput && frmInput.languageCode.length <= 0) {
				list1 && setLanguageName(list1[0].text);
				list1 && setLanguageCode(list1[0].value);
				
				setFrmInput({
					...frmInput,
					languageCode: langList[0].value
				});
			}

			setIsLangListLoaded(true);
			setShowModal(false);
		}
	}

	if (favChannelTitle.trim() == "" && channelData && !channelData.isLoading && channelData.isSuccess && channelData.channelInput != null) {
		setFavChannelTitle(channelData.channelInput.title);
	}

	const handleInputChange = (event) => {
		let name = event.target.name;
		let value = event.target.value;
		if (name === 'email') {
			var val = value.toLowerCase()
			setFrmInput({
				...frmInput,
				[name]: val,
			});
		} else if (name === "avatarUrlUploaded") {
			setError(" ");
			setIsInvalidUrl(false)
			setImagePrevUrl(value);
			setFrmInput({
				...frmInput,
				[name]: value,
			});
		} else {
			setFrmInput({
				...frmInput,
				[name]: value,
			});
		}
		setIsDirty(true)
	};

	const handleDateChange = (date, key) => {
		const name = key;
		const value = moment(date).format("YYYY-MM-DD");
			setFrmInput({
				...frmInput,
				[name]: value,
			});
		setIsDirty(true)
	}

	const handleEditClick = (event) => {
		if (((userData.isLoading === true) || (messageBoardData.isLoading === true) || (userData.isUserNewLoading === true) || (episodeData.isLoading === true) || (channelData.isLoading === true) )&& !isTest) {
			showAlert("Page is loading please wait", true)
		}
		else {
			setIsEditUserData(true);
		}
	};

	const handleLoadShowModal = (value: boolean) => {
		setShowModal(value);
	};

	const handleLanguageChange = (event) => {
		langList && langList.forEach((data: any) => {
			if (data.value === event.target.value) {
				setLanguageName(data.text);
				setLanguageCode(data.value);
			}
		});
	}

	const handleSubmit = (event) => {
		if (isEditUserData) {
			event.preventDefault();
			const isValidImage = validateImage(imagePrevUrl);
			if (!isValidImage || isInvalidUrl) {
				setIsErrorOnPage(true);
				return;
			}
			var inp = frmInput;
			inp.userId = id;
			inp.isActive = isActive;
			inp.isAdmin = isAdmin;
			inp.isDeleted = isDeleted;
			inp.emailsAllowed = emailsAllowed;
			inp.textsAllowed = textsAllowed;
			setformSubmit(true);
			setShowModal(true);
			dispatch(userAction.userSaveCommunity({ user: inp }));
			setIsErrorOnPage(false);
			setError(" ");
			setIsInvalidUrl(false);
		}
	};
	const handleUserUpdateCancel = () => {
		setIsEditUserData(false);
		setEmailsAllowed(userData.item.emailsAllowed);
		setTextsAllowed(userData.item.textsAllowed);
		setImagePrevUrl(userData.item.avatarUrlUploaded || userData.item.avatarImageUrl)
		setFrmInput(userData.item);
		langList && langList.forEach((data: any) => {
			if (data.value === userData.item.languageCode) {
				setLanguageName(data.text);
				setLanguageCode(data.value);
			}
		});

		setIsDirty(false)
		setError(" ")
		setIsInvalidUrl(false)
	}

	const handleUserDeactivateClick = (event) => {
		setShowUserDeactivateModal(true);
	}

	const handleUserDeactivateModal = (value: boolean, isModelClose: boolean) => {
		setShowUserDeactivateModal(false);
		if (value) {
			dispatch(userAction.userUpdateActiveStatus(id));
			setShowModal(true);
		}
	}
	const validateImage = (value: string): boolean => {
		if (!value) return false;

		const allowedExtensions = ['jpg', 'png'];
		const decodedUrl = decodeURIComponent(value.trim());
		const cleanUrl = decodedUrl.split('#')[0].split('?')[0];
		const ext = cleanUrl.split('.').pop()?.toLowerCase();

		if (!ext || !allowedExtensions.includes(ext) || isInvalidUrl) {
			setError("URL cannot be used");
			return false;
		} else {
			setError(" ");
			return true;
		}
	};

	React.useEffect(() => {
		const eventHandler = (event: BeforeUnloadEvent) => {
			var sessionExpiry = window.localStorage.getItem('SESSIONEXPIRY');
			const inSession = Date.now() < Number(sessionExpiry)
			if (!formSubmit && inSession) {
				event.preventDefault();
				event.returnValue = "";
			}
		};
		if (isDirty) { window.addEventListener("beforeunload", eventHandler) }
		return () => { window.removeEventListener("beforeunload", eventHandler) };
	}, [isDirty && !formSubmit])

	

	return (
		<div className="community-member">
			{showModal && (<LoadingSpinnerModal isShowModal={showModal} modalChange={handleLoadShowModal} />)}
			<div className='card-box'>
				<h2>
					<span data-testid="communityMemberTitle">Community Member: {Capitalize(frmInput.firstName)} {Capitalize(frmInput.lastName)}</span>
				</h2>
				<hr />				
				<Row className="cm-row">
					<Col lg={2}>
						<CardImg data-testid="userImage" onError={(e: any) => {e.target.src = (userData.item && (userData?.item?.avatarUrlUploaded || userData?.item?.avatarImageUrl)), setIsInvalidUrl(true)
							}}
							className='card-box-img-icon' top width="100%"
							src={error === " " ? imagePrevUrl || NoImage : (userData.item && (userData?.item?.avatarUrlUploaded || userData?.item?.avatarImageUrl) || NoImage)}
							alt="User Image" />
					</Col>
					<Col lg={4}>
						<table className="table table-bordered" data-testid="userTable">
							{userData && userData.isLoading && !isDetailLoaded && !isTest ?
								<tbody>
									<tr className="dashboard-page-load top-rows">
										<DABInlineLoading />
									</tr>
								</tbody> :
								<tbody>
									<tr>
										<td className="td50" data-testid="lblNickName">Display Name</td>
										<td data-testid="nickName">{frmInput.userName}</td>
									</tr>
									<tr>
										<td data-testid="lblRegisteredAt">Registered At</td>
										<td data-testid="registeredAt">{frmInput.registeredAtUtc != "" ? moment(frmInput.registeredAtUtc).format(dateFormat) : null}</td>
									</tr>
									<tr>
										<td data-testid="lblEmail">Email</td>
										<td data-testid="userName">{frmInput.email}</td>
									</tr>
								</tbody>}
						</table>
					</Col>
					</Row>
				<Row className="map-container">
					<Col lg={6} className="mc-map">
						<ChannelEngegement userId={id} />
					</Col>
					<Col lg={6} className="mc-map">
						<MessageBoardEngagement userId={id} />
					</Col>
				</Row>
			</div>

			<div className='card-box'>
				{userData && userData.isLoading && !isDetailLoaded && !isTest ?
					<div className="dashboard-page-load">
						<DABInlineLoading />
						<p>Processing...Please wait.</p>
					</div> :
						<form onSubmit={handleSubmit}>
							<Row className="cm-row-edit">
								<Col lg={3}>
									<h5 data-testid="userDetails">User Details</h5>
								</Col>
								<Col lg={3}>
									<Button data-testid="userEditButton" type="button" color="primary" value="Edit" onClick={handleEditClick} hidden={isEditUserData}>Edit</Button>
								<Button data-testid="userSaveButton" type="submit" color="primary" value="Save" hidden={!isEditUserData}>Save</Button>
								<Button type="button" className="cancel-button" color="primary" value="Cancel" onClick={ handleUserUpdateCancel} hidden={!isEditUserData}>Cancel</Button>
								</Col>
								<Col lg={8}>
								</Col>
							</Row>
							<Row>
								<Col lg={6}>
									{!isEditUserData &&
										<table className="table table-bordered" data-testid="userDetailViewTable">
											<tbody>
												<tr>
													<td className="td50" data-testid="lblFirstName">First Name</td>
													<td data-testid="firstName">
														{frmInput.firstName}
													</td>
												</tr>
												<tr>
													<td data-testid="lblLastName">Last Name</td>
												<td data-testid="lastName">{frmInput.lastName}</td>
												</tr>
												<tr>
												<td data-testid="lblNickName">Display Name</td>
												<td data-testid="nickNameDetail" style={{ maxWidth: '250px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{frmInput.userName}</td>
												</tr>
												<tr>
													<td data-testid="lblEmail">Email</td>
													<td data-testid="email">{frmInput.email}</td>
												</tr>
												<tr>
												<td data-testid="lblavatarImage">User Avatar Url</td>
												<td style={{ maxWidth: '250px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={imagePrevUrl}
													data-testid="avatarImageUrl">{imagePrevUrl || " "}</td>
												</tr>
												<tr>
													<td data-testid="lblRegisteredDate">Registered Date</td>
													<td data-testid="registeredAtDetail">{moment(frmInput.registeredAtUtc).format(dateFormat)}</td>
												</tr>
												<tr>
													<td data-testid="lblBirthDate">Birth Date</td>
													<td data-testid="birthDate">{(moment(frmInput.birthDate).year() > 1900) ? moment(frmInput.birthDate).format(dateFormat) : ""}</td>
												</tr>
												<tr>
													<td data-testid="lblLanguage">Language</td>
													<td data-testid="languageName">{languageName}</td>
												</tr>
												<tr>
													<td data-testid="lblPhoneNumber">Phone Number</td>
													<td data-testid="phoneNumber">{frmInput.phoneNumber}</td>
												</tr>
												<tr>
											<td data-testid="lblEmailAllowed">Emails Allowed</td>
											<td data-testid="emailAllowed">{frmInput.emailsAllowed ? 'Yes' : 'No'}</td>
												</tr>
												<tr>
											<td data-testid="lblTextsAllowed">Texts Allowed</td>
											<td data-testid="textAllowed">{frmInput.textsAllowed ? 'Yes' : 'No'}</td>
												</tr>
											</tbody>
										</table>
									}
									{isEditUserData &&
										<table className="table table-bordered" data-testid="userDetailEditTable">
											<tbody>
												<tr>
													<td data-testid="lblEditFirstName">First Name</td>
													<td data-testid="firstNameEdit">
														<DABTextBox type="text" id="firstName" isRequired={true} maxLength={100} isHover={false}
															onChange={(event) => { handleInputChange(event) }} value={frmInput.firstName} />
													</td>
												</tr>
												<tr>
													<td data-testid="lblEditLastName">Last Name</td>
													<td data-testid="lastNameEdit">
														<DABTextBox type="text" id="lastName" isRequired={true} maxLength={100} isHover={false}
															onChange={(event) => { handleInputChange(event) }} value={frmInput.lastName} />
													</td>
												</tr>
												<tr>
													<td data-testid="lblEditNickName">Display Name</td>
													<td data-testid="nickNameEdit">
														<DABTextBox type="text" id="nickName" isRequired={false} maxLength={100} isHover={false}
															onChange={(event) => { handleInputChange(event) }} value={frmInput.userName} />
													</td>
												</tr>
												<tr>
													<td data-testid="lblEditEmail">Email</td>
													<td data-testid="emailEdit">
														<DABTextBox type="text" id="email" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$" isRequired={true} maxLength={100} isHover={false}
															onChange={(event) => { handleInputChange(event) }} value={frmInput.email} />
													</td>
											</tr>
											<tr>
												<td data-testid="lblEditavatarImageUrl"> User Avatar Url</td>
												<td data-testid="avatarUrlEdit">
													<DABTextBox type="text" id="avatarUrlUploaded" isRequired={true} isHover={false}
														onChange={(event) => { handleInputChange(event) }} value={imagePrevUrl} />
													{error != " " && <p className="error-text">{error}</p>}
												</td>
											</tr>
												<tr>
													<td data-testid="lblEditRegisteredDate">Registered Date</td>
													<td data-testid="registeredAtEdit">
														<DatePicker
															className="form-control"
															showMonthDropdown
															showYearDropdown
															dropdownMode="select"
															dateFormat="MM/dd/yyyy"
															selected={frmInput.registeredAtUtc.substring(0, 10) != "" ? new Date(frmInput.registeredAtUtc.substring(0, 10)) : null}
															onChange={(event) => { handleDateChange(event, 'registeredAtUtc') }}
															placeholderText="MM/DD/YYYY"
															onKeyDown={(e) => { e.preventDefault() }}
														/>
													</td>
												</tr>
												<tr>
													<td data-testid="lblEditBirthDate">Birth Date</td>
													<td data-testid="birthDateEdit">
														<DatePicker
															className="form-control"
															showMonthDropdown
															showYearDropdown
															dropdownMode="select"
															dateFormat="MM/dd/yyyy"
															selected={frmInput.birthDate.substring(0, 10) != "" ? new Date(frmInput.birthDate.substring(0, 10)) : null}
															onChange={(event) => { handleDateChange(event, 'birthDate') }}
															placeholderText="MM/DD/YYYY"
															onKeyDown={(e) => { e.preventDefault() }}
														/>
													</td>
												</tr>
												<tr>
													<td data-testid="lblEditLanguage">Language</td>
													<td data-testid="languageEdit">
														<DABDropDown id="languageCode" value={frmInput.languageCode} isRequired={true} isHover={false}
															onChange={(event) => { handleInputChange(event); handleLanguageChange(event); }} options={langList} />
													</td>
												</tr>
												<tr>
													<td data-testid="lblEditPhoneNumber">Phone Number</td>
													<td data-testid="phoneNumberEdit">
														<DABTextBox type="text" id="phoneNumber" pattern="[0-9]{10}" maxLength={100} title="Phone Number can accept only 10 digits" isRequired={false} isHover={false}
															onChange={(event) => { handleInputChange(event) }} value={frmInput.phoneNumber} />
													</td>
												</tr>
												<tr>
													<td className="td50" data-testid="lblEditEmailsAllowed">Emails Allowed</td>
													<td>
														<div data-testid="emailAllowedEdit">
													<Input className='box-container-input' type="checkbox" id="emailsAllowed" name="emailsAllowed"
														checked={emailsAllowed} onChange={() => { setEmailsAllowed(!emailsAllowed) }} />
														</div>
													</td>
												</tr>
												<tr>
													<td data-testid="lblEditTextsAllowed">Texts Allowed</td>
													<td>
														<div data-testid="textAllowedEdit">
													<Input className='box-container-input' type="checkbox" id="textsAllowed" name="textsAllowed"
														checked={textsAllowed} onChange={()=>{ setTextsAllowed(!textsAllowed) }} />
														</div>
													</td>
												</tr>
											</tbody>
										</table>
									}
								</Col>
								<Col lg={6}>
									<Row><h6><div data-testid="textFavoriteChannel"> Followed Channels:</div> <a href={"/channel?id=" + favChannelId} data-testid="textFavoriteChannelLink">{" " + favChannelTitle}</a></h6></Row>
									<table className="table table-bordered text-center" data-testid="tableFavouriteChannel">
										<thead>
											<tr>
												<th className="td50" data-testid="otherChannelTitle" key={"favChannel"} scope="col">Channel</th>
												<th key={"lastTime"} data-testid="otherChannelDate" scope="col">Last Interaction</th>
											</tr>
										</thead>
										<tbody>
											{!showFavChnModal && favChannelList && favChannelList.map((data: any) =>
												<tr key={"otherChannelRow" + data.channelId}>
													<td data-testid={"otherChannel" + data.channelId} key={data.title + data.channelId}>
														<a className="detail-link" href={"/channel?id=" + data.channelId} data-testid={"otherChannelLink" + data.channelId}>{data.title}</a>
													</td>
													<td data-testid={"otherChannelDate" + data.channelId} key={data.lastInteraction}>
														{moment(data.lastInteraction).format(dateFormat)}</td>
												</tr>
											)}
											{showFavChnModal &&
												<tr>
													<td colSpan={2} style={{ verticalAlign: "middle" }}>
														<DABInlineLoading />
													</td>
												</tr>
											}
											{!showFavChnModal && favChannelList.length <= 0 &&
												<tr>
													<td colSpan={2} style={{ verticalAlign: "middle" }}>
														No followed channels yet
													</td>
												</tr>
											}
										</tbody>
									</table>
									<Row data-testid="textOtherChannel"><h6>Other Channels</h6></Row>
									<table className="table table-bordered text-center" data-testid="tableFavouriteChannel">
										<thead>
											<tr>
												<th className="td50" data-testid="otherChannelTitle" key={"favChannel"} scope="col">Channel</th>
												<th key={"lastTime"} data-testid="otherChannelDate" scope="col">Last Interaction</th>
											</tr>
										</thead>
										<tbody>
											{!shownonFavChnModal && nonFavChannelList && nonFavChannelList.map((data: any) =>
												<tr key={"otherChannelRow" + data.channelId}>
													<td data-testid={"otherChannel" + data.channelId} key={data.title + data.channelId}>
														<a className="detail-link" href={"/channel?id=" + data.channelId} data-testid={"otherChannelLink" + data.channelId}>{data.title}</a>
													</td>
													<td data-testid={"otherChannelDate" + data.channelId} key={data.lastInteraction}>
														{moment(data.lastInteraction).format(dateFormat)}</td>
												</tr>
											)}
											{shownonFavChnModal &&
												<tr>
													<td colSpan={2} style={{ verticalAlign: "middle" }}>
														<DABInlineLoading />
													</td>
												</tr>
											}
											{!shownonFavChnModal && nonFavChannelList.length <= 0 &&
												<tr>
													<td colSpan={2} style={{ verticalAlign: "middle" }}>
														No Data Found
													</td>
												</tr>
											}
										</tbody>
									</table>
									{isEditUserData &&
										<table className="table" data-testid="userDetailSecondEditTable">
											<tbody>
												<tr>
													<td className="td50" data-testid="lblEditIsActive">Active</td>
													<td>
														<div className="" data-testid="isActiveEdit">
															<input className="form-check-input" type="checkbox" id="isActive" name="isActive"
																checked={isActive} disabled={!isEditUserData} onChange={() => { setIsActive(!isActive); }} />
														</div>
													</td>
												</tr>
												<tr>
													<td data-testid="lblEditIsAdmin">Administrator</td>
													<td>
														<div className="" data-testid="isAdminEdit">
															<input className="form-check-input" type="checkbox" id="isAdmin" name="isAdmin"
																checked={isAdmin} disabled={!isEditUserData} onChange={() => { setIsAdmin(!isAdmin); }} />
														</div>
													</td>
												</tr>
												<tr>
													<td data-testid="lblEditIsDeleted">Deleted</td>
													<td>
														<div className="" data-testid="isDeletedEdit">
															<input className="form-check-input" type="checkbox" id="isDeleted" name="isDeleted"
																checked={isDeleted} disabled={!isEditUserData} onChange={() => { setIsDeleted(!isDeleted); }} />
														</div>
													</td>
												</tr>
											</tbody>
										</table>
									}
									{!isEditUserData &&
										<table className="table" data-testid="userDetailSecondViewTable">
											<tbody>
												<tr>
													<td className="td50" data-testid="lblIsActive">Active</td>
													<td data-testid="isActive">{isActive ? 'Yes' : 'No'}</td>
												</tr>
												<tr>
													<td data-testid="lblIsAdmin">Administrator</td>
													<td data-testid="isAdmin">{isAdmin ? 'Yes' : 'No'}</td>
												</tr>
												<tr>
													<td data-testid="lblIsDeleted">Deleted</td>
													<td data-testid="isDeleted">{isDeleted ? 'Yes' : 'No'}</td>
												</tr>
											</tbody>
										</table>
									}
								</Col>
						</Row>
						

							<ConfirmModal data-testid="modalDeactivateUser" isShowModal={showUserDeactivateModal}
								deleteMessage={"Are you sure, Do you want to deactivate this user? "}
								modalChange={handleUserDeactivateModal} />

					</form>}
				{isDetailLoaded && <>
					<Row >
						<Col>
							<UserAddress userId={id} showSearch={true} title="Addresses" isActive={isActive} />
						</Col>
					</Row>
					<br />
					<hr className="hrLine" />

					<UserMessages userId={id} showSearch={true} title="Messages" />

					<br />
					<hr className="hrLine" />

					<UserPurchaseDetail userId={id} showSearch={true} title="Orders" />

					<br />
					<hr className="hrLine" />

					<EpisodeEngagement userId={id} showSearch={true} title="Episode Engagement" />

					{/*<UserRole id={id} isActive={isActive} />*/}

					<Row><h5>Actions</h5></Row>

					<div data-testid="deactivateUserButtonContainer" className="deactivate-user">
						<Button type="button" color="primary" value="Deactivate" onClick={handleUserDeactivateClick} disabled={!isActive}>Deactivate User</Button>
					</div></>}
			</div>
		</div>
	)
}

const mapStateToProps = (state: any) => {
	const { channelData, userData, languageData, messageBoardData, episodeData } = state;
	return {
		channelData, userData, languageData, messageBoardData, episodeData
	};
};

export default connect(mapStateToProps)(UserDetail);
